import Vue from "vue";

//import SelfAssessmentTools from './components/SATs.vue'
import store from "./store";
import { privateRouter, publicRouter } from "./router";
/* import publicRouter from "./router-public.js"; */
import App from "@/App";
/* import AppLogin from "./app-login.vue";
 */ import { Tabs, Tab } from "vue-tabs-component";
import Vuelidate from "vuelidate";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faExclamationCircle,
  faAngleRight,
  faAngleLeft,
  faPencilAlt
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import $ from "jquery";
import VueBreadcrumbs from "vue-breadcrumbs";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { HomeUrl, SATUrl } from "./shared/config.js";

Vue.config.productionTip = false;

Vue.component("tabs", Tabs);
Vue.component("tab", Tab);
Vue.use(Vuelidate);

library.add({ faExclamationCircle, faAngleRight, faAngleLeft, faPencilAlt });
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(VueBreadcrumbs, {
  template:
    '<nav class="breadcrumb" v-if="$breadcrumbs.length"><div class="content-wrapper">' +
    `<span>You are here: </span><a class="breadcrumb-item" href="${HomeUrl}">Home </a><a class="breadcrumb-item" href="${SATUrl}">Self-assessment </a>` +
    '<router-link class="breadcrumb-item" v-for="(crumb, key) in $breadcrumbs" :to="linkProp(crumb)" :key="key">{{ crumb | crumbText }}</router-link> ' +
    "</div></nav>"
});


Vue.directive("animate", {
  bind: function(el) {
    el.onclick = function() {
      var parent = el.parentNode;
      if (parent) {
        var field = parent.querySelector("select,input"); 
        if (field) field.focus();
      }
    };
  }
});
Vue.directive("flyout", {
  bind: function(el) {
    var value = el.querySelector("select,input").value;
    if (value) {
      el.classList.add("hasValue");
    } else {
      el.classList.remove("hasValue");
    }
    (el.onfocusout = function() {
      var value = el.querySelector("select,input").value;
      if (value) {
        el.classList.add("hasValue");
      } else {
        el.classList.remove("hasValue");
      }
    }),
      (el.onclick = function() {
        var value = el.querySelector("select,input").value;
        if (value) {
          el.classList.add("hasValue");
        } else {
          el.classList.remove("hasValue");
        }
      });
  }
});

if ($("#app").length) {
  new Vue({
    router: privateRouter,
    store,
    render: h => h(App)
  }).$mount("#app");
}

if ($("#applogin").length) {
  new Vue({
    router: publicRouter,
    store,
    render: h => h(App)
  }).$mount("#applogin");
}
